import React from 'react';
import PropTypes from 'prop-types';
import Slick from 'react-slick';
import { connect } from 'react-redux';
import {translate} from "react-i18next";

import Step from './Step';
import { resetPhoneClick, registerButtonClick } from '../../actions';
import FloatingLabelInput from '../../../common/FloatingLabelInput';

@translate(['register'], {wait:true})
class ActivationStep extends Step {
  constructor(props) {
    super(props);

    this.state = {
      imei: '',
      packageId: '',
      isFormSubmitted: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        isFormSubmitted: false,
      });
    }
    if (nextProps.registerSucceeded) {
      this.props.increaseStepIndex();
    }
  }

  handleBackClick(e) {
    e.preventDefault();
    this.props.resetPhone();
    console.log(this.props)
    this.props.decreaseStepIndex()
  }

  handleNextClick(e) {
    e.preventDefault();
    // this.props.increaseStepIndex()
    this.props.registerUser({
      phone: this.props.phone,
      imei: this.state.imei,
      packageId: this.state.packageId,
    });
  }

  renderFirstScreen() {
    const {t, phone} = this.props;
    return (
      <div>
        <a onClick={this.handleBackClick} className="backStep" href=""></a>
        <div className="container">
          <form className="popupForm popupActivationForm" action="#">
            <div className="stepTitle">
              <h2>{t('register:activation')}</h2>
              <p>{t('register:register')}</p>
            </div>
            { !phone.startsWith('+55') &&
              <div className="popupGallery">
                <Slick
                  ref="slider"
                  className="popupGallery__holder"
                  arrows={false}
                  centerMode
                  variableWidth
                  infinite={false}
                  dots={ true }
                >
                  <div className="popupGallery__item"><img width="342" src="images/img-booklet.jpg" data-rjs="images/2x/img-booklet.jpg" alt="booklet" /></div>
                  <div className="popupGallery__item"><img width="292" src="images/img-box.jpg" data-rjs="images/2x/img-box.jpg" alt="box" /></div>
                  <div className="popupGallery__item"><img width="209" src="images/img-adapter.jpg" data-rjs="images/2x/img-adapter.jpg" alt="adapter" /></div>
                </Slick>

                <a onClick={e => {
                  e.preventDefault();
                  this.refs.slider.slickPrev();
                }} className="popupGallery__arrow popupGallery__arrow--prev" href=""/>
                <a onClick={e => {
                  e.preventDefault();
                  this.refs.slider.slickNext();
                }} className="popupGallery__arrow popupGallery__arrow--next" href=""/>
              </div>
            }
            <div className="popupForm__body">
              <div className="form-row row colRow error">
                <div className="col col-6">
                  <FloatingLabelInput className="inputText" type="text" label={t('register:package_id')} defaultValue={this.state.packageId} onChange={e => {
                    this.setState({
                      packageId: e.target.value,
                    });
                  }}/>
                </div>
                <div className="col col-6">
                  <FloatingLabelInput className="inputText" type="text" label={t('register:imei')} defaultValue={this.state.imei} onChange={e => {
                    this.setState({
                      imei: e.target.value,
                    });
                  }} />
                </div>
                {this.props.error ? <span className="error-message error-message-block">{t('register:wrong_package_id_or_imei')} <br /> {t('register:wrong_package_id_or_imei_2')}</span> : null}
              </div>
            </div>
            <div className="rowButton">
              <button
              disabled={this.state.imei.length === 0 || this.state.packageId.length === 0}
              onClick={(e) => {
                e.preventDefault();
                this.setState({isFormSubmitted: true});
              }} className="btn"><span>{t('register:continue')}</span></button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  renderSecondScreen() {
    const {t} = this.props;
    return (
      <div>
        <a onClick={(e) => {
          e.preventDefault();
          this.setState({isFormSubmitted: false});
        }} className="backStep" href=""></a>
        <div className="container">
          <form className="popupForm popupActivationForm" action="#">
            <div className="stepTitle">
              <h2>{t('register:agreements')}</h2>
              <p>{t('register:agreements_1')}</p>
            </div>
            <div className="popupForm__body">
              <ul className="agreementList">
                <li><a href="">{t('register:agreements_2_1')}</a></li>
                <li><a href="">{t('register:agreements_2_2')}</a></li>
              </ul>
            </div>
            <div className="rowButton">
              <button className="btn" onClick={this.handleNextClick}>{t('register:agreements_accept')}</button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  render() {
    return (
      this.state.isFormSubmitted ?
      this.renderSecondScreen() : this.renderFirstScreen()
    );
  }
}

ActivationStep.propTypes = {
  registerSucceeded: PropTypes.bool,
  error: PropTypes.bool,
  phone: PropTypes.string,
  resetPhone: PropTypes.func,
  registerUser: PropTypes.func,
  increaseStepIndex: PropTypes.func,
};

export default connect(
  (state) => {
    return {
      phone: state.auth.phone,
      error: state.auth.registerError,
      registerSucceeded: state.auth.registerSucceeded,
    };
  },
  (dispatch) => {
    return {
      resetPhone() {
        return dispatch(resetPhoneClick());
      },
      registerUser(payload) {
        console.log(payload)
        return dispatch(registerButtonClick(payload));
      },
    };
  }
)(ActivationStep);



// WEBPACK FOOTER //
// ./src/components/Auth/Registration/Steps/ActivationStep.js